/**
 * Created by User on 10/5/2016.
 */
import PageComponent from '../base/PageComponent';

export default class CoverOrderForm extends PageComponent {
    constructor(element) {
        super(element);
    }

    init(){
        this.element.find('#CoverOrderForm_CoverOrderForm_CoverShape input').on('change', e => this.showMessage(e));
    }

    showMessage(e){
        var isChecked = $('#CoverOrderForm_CoverOrderForm_CoverShape_Template').is(':checked');
        if(isChecked){
            $('#TemplateShape').show();
        }
        else{

            $('#TemplateShape').hide();
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/components/CoverOrderForm.js